import CommonService from './common.service'

import { httpParams } from 'utils/interfaces'

class SecessionService extends CommonService {
  async register(params: httpParams) {
    return await this.post('/register', params)
  }

  async accountVerification(params: httpParams) {
    return await this.post('/account-verification', params)
  }

  async resendVerification(params: httpParams) {
    return await this.post('/resend-verification', params)
  }

  async resetPassword(params: httpParams) {
    return await this.post('/update-password', params)
  }

  async login(params: httpParams) {
    return await this.post('/login', params)
  }

  async resetPasswordEmail(params: httpParams) {
    return await this.post('/reset-password-email', params)
  }

  async changePassword(params: httpParams) {
    return await this.post('/change-password', params)
  }

  async sendEnquries(params: httpParams) {
    return await this.post('enquries', params)
  }

  async addBusiness(params: httpParams) {
    return await this.post('add-business', params)
  }
}
export const secessionService = new SecessionService()
